import { collection, getFirestore, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { BlogPost, mergeBlogPosts } from "./blogContent";
import { app } from "./components/firebase-config";

type PublicBlogPostsState = {
  posts: BlogPost[];
  loading: boolean;
};

const isBlogPost = (value: unknown): value is BlogPost => {
  if (!value || typeof value !== "object") {
    return false;
  }
  const post = value as Partial<BlogPost>;
  return Boolean(
    post.slug &&
    post.date &&
    post.translations?.en &&
    post.translations?.ko &&
    post.translations?.ja
  );
};

export const usePublicBlogPosts = (): PublicBlogPostsState => {
  const [state, setState] = useState<PublicBlogPostsState>({
    posts: mergeBlogPosts([]),
    loading: true,
  });

  useEffect(() => {
    const db = getFirestore(app);
    const unsubscribe = onSnapshot(
      collection(db, "publicBlogPosts"),
      (snapshot) => {
        const dynamicPosts: BlogPost[] = [];
        for (const document of snapshot.docs) {
          const post = document.data();
          if (isBlogPost(post)) {
            dynamicPosts.push(post);
          }
        }
        setState({posts: mergeBlogPosts(dynamicPosts), loading: false});
      },
      (error) => {
        console.error("Failed to load public blog posts:", error);
        setState({posts: mergeBlogPosts([]), loading: false});
      }
    );
    return () => unsubscribe();
  }, []);

  return state;
};
